import {MutationOptions, useMutation} from 'react-query';
import { API_URL, APIError, APIResponse, post } from '../api';

function useCreatePin<T>(
  options?: MutationOptions<APIResponse<T>, APIError, {pin: string}>,
) {
  const {
    mutate: createPin,
    isLoading: creatingPin,
    isError: isCreatePinError,
    error: createPinError,
  } = useMutation(
    async variables =>
      await post(API_URL + '/account/user/security/create-pin', variables, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ localStorage.getItem('token')}`,
        },
      }),
    options,
  );

  return {
    createPin,
    creatingPin,
    isCreatePinError,
    createPinError,
  };
}

export default useCreatePin;
